import React from 'react';
import { trackPropTypes } from "../../../config/defaults";
import SkierIcon from "../../UI/SkierIcon";
import Label from "@/components/UI/Label";
import {
	getLearningAreaColors,
	getLearningAreaLabelColors
} from "@/config/learningAreas";

/**
 * Навчальний майданчик 1D
 *
 * Координати з Figma:
 * - Позиція на карті: translate(1148, 1001.46)
 * - Розмір області: 43 × 45.54 px
 *
 * TODO: Додати SVG path для області майданчика
 */

const Track1DGreen = ({ state, workState, onLabelClick }) => {
	const colors = getLearningAreaColors(state, workState);
	const labelColors = getLearningAreaLabelColors(state, workState);

	return (
		<g id="Track1DGreen" transform="translate(1148, 1001.46)" className="learning-area">
			{/* TODO: Додати зелену лінію (connector) якщо потрібно */}
			{/*<g transform="translate(TODO, TODO)">*/}
			{/*	<path d="TODO - вставте path з SVG" stroke={colors.areaBorder} strokeLinecap="round"/>*/}
			{/*</g>*/}

			<g transform="translate(12, 26)">
				<path d="M6.99976 8C3.40999 8 0.499906 5.08992 0.499899 1.50015L0.499897 0.499969" stroke={colors.connector}
							strokeLinecap="round"/>
			</g>


			<g transform="translate(10, 0)">
				<path
					d="M13.5359 0.638489L32.6169 1.10138C35.0478 1.16044 35.9677 4.30598 33.9519 5.66583L4.91968 25.2518C3.29947 26.3444 1.10898 25.2356 1.03003 23.283L0.645264 13.7381C0.352522 6.46835 6.26243 0.462373 13.5359 0.638489Z"
					fill="white" fillOpacity="0.7"/>
				<path
					d="M13.5359 0.638489L32.6169 1.10138C35.0478 1.16044 35.9677 4.30598 33.9519 5.66583L4.91968 25.2518C3.29947 26.3444 1.10898 25.2356 1.03003 23.283L0.645264 13.7381C0.352522 6.46835 6.26243 0.462373 13.5359 0.638489Z"
					fill={colors.areaFill}/>
				<path
					d="M13.5359 0.638489L32.6169 1.10138C35.0478 1.16044 35.9677 4.30598 33.9519 5.66583L4.91968 25.2518C3.29947 26.3444 1.10898 25.2356 1.03003 23.283L0.645264 13.7381C0.352522 6.46835 6.26243 0.462373 13.5359 0.638489Z"
					stroke={colors.areaBorder} strokeWidth="1.27015"/>
			</g>

			<g transform="translate(13.5, 2.77)">
				<rect
					width="16"
					height="16"
					rx="8"
					fill={colors.skierBg}
				/>
				<g transform="translate(3, 3)">
					<SkierIcon color="white" size={12} variant="simple"/>
				</g>
			</g>

			{/* Мітка 1D */}
			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track1DGreen')}
				coords="23, 20"
				text="1D"
				textCoordsX="8"
				textCoordsY="16"
				colors={labelColors.colors}
				textColor={labelColors.textColor}
				textSize={10}
				size="small"
			/>
		</g>
	);
};

Track1DGreen.propTypes = trackPropTypes;

export default Track1DGreen;
